export const DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
export const DAGEN_KORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];

export function fmtDatum(d: string | number | Date): string {
  return new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function fmtDatumKort(d: string | number | Date): string {
  return new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });
}

export function fmtTijd(d: string | number | Date): string {
  return new Date(d).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
}

export function fmtDatumTijd(d: string | number | Date): string {
  return `${fmtDatumKort(d)} · ${fmtTijd(d)}`;
}

/** 'vandaag', 'gisteren', '3 dagen geleden' — voor het dashboard. */
export function relatief(d: string | number | Date): string {
  const dagen = Math.floor((Date.now() - new Date(d).getTime()) / 86400000);
  if (dagen <= 0) return 'vandaag';
  if (dagen === 1) return 'gisteren';
  if (dagen < 7) return `${dagen} dagen geleden`;
  /* Eén week is geen "1 weken". Het enkelvoud valt maar in twee gevallen, dus
     dat scheelt een hele lijst met meervoudsvormen. */
  const weken = Math.floor(dagen / 7);
  if (dagen < 31) return weken === 1 ? 'vorige week' : `${weken} weken geleden`;
  const maanden = Math.floor(dagen / 30);
  return maanden === 1 ? 'vorige maand' : `${maanden} maanden geleden`;
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function datumVeld(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function tijdVeld(d: Date): string {
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function maandSleutel(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
}

/**
 * Hoe een speler in de competitie heet: zijn gebruikersnaam, met een @ ervoor.
 *
 * Binnen een poule tonen we niet de burgerlijke naam maar de gebruikersnaam —
 * dat is ook waarmee je iemand uitnodigt, dus het is de naam die er in de app
 * toe doet. Wie er nog geen heeft valt terug op zijn naam, anders staat er een
 * lege plek. Op het gebruikersbeheer blijft de echte naam staan; daar gaat het
 * juist over de persoon achter het account.
 */
export function toonNaam(speler: { name: string; username?: string | null }): string {
  return speler.username ? `@${speler.username}` : speler.name;
}

/**
 * Naam én gebruikersnaam. Voor lijsten waarin je iemand moet aanwijzen: daar
 * is alleen een naam te weinig als er twee Toms rondlopen, en alleen een
 * gebruikersnaam te weinig als je die van je collega's niet uit je hoofd kent.
 */
export function naamVoluit(speler: { name: string; username?: string | null }): string {
  return speler.username ? `${speler.name} (@${speler.username})` : speler.name;
}

/** De initialen die bij die weergavenaam horen; de @ telt niet mee. */
export function initialenVan(speler: { name: string; username?: string | null }): string {
  return initialen(toonNaam(speler).replace(/^@/, ''));
}

export function initialen(naam: string): string {
  return (naam || '?')
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export function toonRating(r: number): number {
  return Math.round(r);
}

export function toonDelta(d: number): string {
  const afgerond = Math.round(d);
  return `${afgerond >= 0 ? '+' : ''}${afgerond}`;
}
